import React from "react";
import LegalFooter from "../components/LegalFooter";

/* ================= STYLES ================= */

const s = {
  page: {
    width: "100%",
    padding: "60px 24px 80px",
  },

  header: {
    textAlign: "center",
    marginBottom: 40,
  },

  title: {
    fontSize: "clamp(34px, 6vw, 52px)",
    fontWeight: 800,
    background: "linear-gradient(90deg,#9333ea,#ec4899)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subTitle: {
    marginTop: 10,
    fontSize: 14,
    opacity: 0.7,
  },

  sectionTitle: {
    textAlign: "center",
    fontSize: 22,
    fontWeight: 700,
    color: "#a855f7",
    marginTop: 50,
  },

  subSectionTitle: {
    fontSize: 17,
    fontWeight: 600,
    color: "#c084fc",
    margin: "22px 0 10px",
  },

  text: {
    fontSize: 15,
    lineHeight: 1.8,
    marginBottom: 14,
  },

  sectionDivider: {
    width: 260,
    margin: "18px auto 28px",
    borderBottom: "2px dotted rgba(147,51,234,0.55)",
  },

  faqDivider: {
    width: "100%",
    margin: "24px 0",
    borderBottom: "1.5px dotted rgba(147,51,234,0.35)",
  },

  socialRow: {
    display: "flex",
    justifyContent: "center",
    gap: 30,
    marginTop: 30,
    flexWrap: "wrap",
  },

  socialCard: {
    width: 150,
    height: 100,
    borderRadius: 18,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    cursor: "pointer",
    gap: 8,
  },

  icon: {
    width: 32,
    height: 32,
  },
  contentBlock: {
    textAlign: "left",
    width: "100%",
  },

  faqSubTitle: {
    marginTop: 16, // ~1 line
    marginBottom: 32, // ~2 lines gap before questions
    textAlign: "center",
    fontSize: "clamp(16px, 4vw, 25px)",
    letterSpacing: "1px",
    textTransform: "uppercase",
    opacity: 0.65,
    color: "#c084fc",
  },
};

/* ================= PAGE ================= */

export default function Contact() {
  const open = (url) => window.open(url, "_blank");

  return (
    <div style={s.page}>
      {/* HEADER */}
      <div style={s.header}>
        <div style={s.title}>Contact Us</div>
        <div style={s.subTitle}>We’d love to hear from you</div>
      </div>

      {/* SUPPORT */}
      <div style={s.contentBlock}>
        <h3 style={s.subSectionTitle}>Email</h3>
        <p style={s.text}>speeddigitstrainer@gmail.com</p>

        <h3 style={s.subSectionTitle}>Phone</h3>
        <p style={s.text}>+91 XXXXX XXXXX</p>

        <h3 style={s.subSectionTitle}>Address</h3>
        <p style={s.text}>SpeedDigits Trainer, India</p>
      </div>

      {/* SOCIAL */}
      <div>
        <div style={s.sectionTitle}>Social & Community</div>
        <div style={s.sectionDivider} />

        <p style={{ textAlign: "center", opacity: 0.85 }}>
          For news, updates, and new features
          <br />
          follow us on social media
        </p>

        <div style={s.socialRow}>
          {/* YouTube */}
          <div
            style={{ ...s.socialCard, background: "#ff0000" }}
            onClick={() => open("https://www.youtube.com/@SpeedDigitsTrainer")}
          >
            <div
              style={{
                width: 40,
                height: 30,
                border: "1.5px solid #fff",
                borderRadius: 7,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/75/YouTube_social_white_squircle_%282017%29.svg"
                alt="YouTube"
                style={{ width: 40, height: 30 }}
              />
            </div>
            YouTube
          </div>

          {/* Instagram */}
          <div
            style={{
              ...s.socialCard,
              background:
                "linear-gradient(135deg,#f58529,#dd2a7b,#8134af,#515bd4)",
            }}
            onClick={() =>
              open("https://www.instagram.com/speeddigitstranier/")
            }
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              style={s.icon}
            />
            Instagram
          </div>

          {/* X */}
          <div
            style={{ ...s.socialCard, background: "#000" }}
            onClick={() => open("https://x.com/Speeddigits_T")}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6f/Logo_of_Twitter.svg"
              style={s.icon}
            />
            X
          </div>

          {/* LinkedIn */}
          <div
            style={{ ...s.socialCard, background: "#0a66c2" }}
            onClick={() =>
              open("https://www.linkedin.com/in/speeddigits-trainer-b76b273a3")
            }
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
              style={s.icon}
            />
            LinkedIn
          </div>
        </div>
      </div>

      {/* FAQS */}
      <div>
        <div style={s.sectionTitle}>FAQs</div>
        <div style={s.sectionDivider} />

        <div style={s.faqSubTitle}>Frequently Asked Questions</div>

        <div style={s.contentBlock}>
          <h3 style={s.subSectionTitle}>❓ What is SpeedDigits Trainer?</h3>
          <p style={s.text}>
            SpeedDigits Trainer is an interactive arithmetic training platform
            designed to improve calculation speed, accuracy, and consistency
            through structured practice sessions and detailed performance
            analysis.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ Is login required to use SpeedDigits Trainer?
          </h3>
          <p style={s.text}>
            SpeedDigits Trainer supports both guest access and signed-in usage.
            However, certain advanced features are available only after signing
            in to ensure data persistence and personalized tracking.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What features are available to guest users?
          </h3>
          <p style={s.text}>Guest users can:</p>
          <ul style={s.text}>
            <li>Practice calculations</li>
            <li>Take tests in supported modes</li>
            <li>Experience the core training functionality</li>
          </ul>
          <p style={s.text}>Guest users cannot access:</p>
          <ul style={s.text}>
            <li>Test history storage</li>
            <li>Detailed analysis pages</li>
            <li>Reset history options</li>
            <li>Export test data</li>
          </ul>
          <p style={s.text}>
            All guest activity is temporary and is not saved.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What additional features do signed-in users get?
          </h3>
          <p style={s.text}>After signing in, users gain access to:</p>
          <ul style={s.text}>
            <li>Persistent test history</li>
            <li>Detailed performance analysis</li>
            <li>Accuracy, timing, and trend graphs</li>
            <li>Test history reset options</li>
            <li>Exporting test results (CSV / Excel)</li>
          </ul>
          <p style={s.text}>
            Signing in ensures progress and data are preserved across sessions.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ Can I access test history and analysis without signing in?
          </h3>
          <p style={s.text}>
            No. Test history, analysis, reset options, and export functionality
            are restricted to signed-in users only. This ensures accurate data
            tracking and prevents accidental data loss.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>❓ How is my information handled?</h3>
          <p style={s.text}>
            All profile and test-related data for signed-in users is stored
            securely according to application policies. Guest users’ data is
            stored temporarily in the browser and may be cleared automatically.
            No personal data is shared with third parties.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What happens if I clear or reset data?
          </h3>
          <p style={s.text}>
            Reset actions permanently remove selected or complete stored test
            data. Once cleared, the application returns to a fresh state and
            previously stored information cannot be recovered.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What practice and test modes are available?
          </h3>
          <p style={s.text}>
            SpeedDigits Trainer provides multiple practice and test modes
            designed around internationally recognized mental calculation
            standards, including formats relevant to competitive and
            aptitude-based examinations.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>❓ How is accuracy calculated?</h3>
          <p style={s.text}>
            Accuracy is calculated as the ratio of correct answers to total
            attempted questions. If no questions are attempted, accuracy is
            displayed safely without misleading values.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What do “Fastest” and “Slowest” times represent?
          </h3>
          <p style={s.text}>
            <strong>Fastest</strong>: Minimum response time during a test
            <br />
            <strong>Slowest</strong>: Maximum time spent on a single question
            <br />
            These metrics help analyze speed consistency and time management.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ Do I get performance graphs and analysis?
          </h3>
          <p style={s.text}>
            Yes. Signed-in users can access graphical insights showing accuracy
            trends, response time distribution, fastest and slowest attempts,
            and overall performance progression.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>❓ Can I export my test results?</h3>
          <p style={s.text}>
            Yes, but only for signed-in users. Test history can be exported as
            CSV or Excel files, filtered by test number, date range, or test
            type.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ What is the difference between “Reset Test History” and “Clear
            Everything”?
          </h3>
          <p style={s.text}>
            <strong>Reset Test History</strong> removes selected test records
            while preserving profile data and settings.
            <br />
            <strong>Clear Everything</strong> removes all stored data and
            restores the application to its initial state.
          </p>

          <div style={s.faqDivider} />

          <h3 style={s.subSectionTitle}>
            ❓ Is an internet connection required?
          </h3>
          <p style={s.text}>
            Yes. SpeedDigits Trainer is a web-based application and requires an
            active internet connection to access and use. While some data is
            stored locally, the application itself must be accessed online.
          </p>

          <LegalFooter styles={s} />
        </div>
      </div>
    </div>
  );
}
